/**
 * 관리자 회원 리텐션 분석 — 개요(홈)
 * ($j.Pages.Admin.StatOverview / body data-page-name="StatOverview")
 *
 * 5개 분석의 헤드라인 숫자 + 바로가기. 무거운 표/차트는 각 상세 탭에.
 */
export default class StatOverview {
    initialize() {
        $('#ovRefresh').on('click', () => this._load(true));
        this._load();
    }

    async _load(nocache = false) {
        try {
            const res = await $.ajax({
                url: '/adm/ajax/stat/overview/data', type: 'get',
                data: nocache ? { nocache: 1 } : {}
            });
            if (!res.ok) return;
            this._render(res);
            if (res.cached_at) $('#ovCachedAt').text(`집계시각 ${res.cached_at} · ${this._fmt(res.month_code)} 기준`);
        } catch (e) {
            console.error('통계 개요 로드 실패', e);
        }
    }

    _render(r) {
        // ① 이탈방어 + ② 깔때기
        $('#ovRate').text(r.fulfillment.rate + '%');
        $('#ovRisk').text(this._c(r.fulfillment.risk_cnt) + '명');
        $('#ovFunnel').text(`${this._c(Math.round(r.funnel.candidates))}→${this._c(Math.round(r.funnel.alerted))}→${r.funnel.win_rate}%`);

        // ③ 공급-수요
        const w = r.supply.worst;
        $('#ovWorst').text(w ? `${w.sido} ${w.car_type} ${w.ratio}` : '-');
        const u = r.supply.unserved;
        $('#ovUnserved').text(u ? `${u.car_type} ${this._c(u.supply)}건` : '없음');

        // ④ 분배 공정성
        $('#ovGini').text(r.fairness.gini);
        $('#ovTop10').text(r.fairness.top10_share + '%');
        $('#ovZero').text(r.fairness.zero_pct + '%');

        // ⑤ 코호트
        $('#ovFwWon').text(r.cohort.first_win_won != null ? r.cohort.first_win_won + '%' : '-');
        $('#ovFwNot').text(r.cohort.first_win_not != null ? r.cohort.first_win_not + '%' : '-');
    }

    _fmt(mc) {
        const s = String(mc);
        return s.length === 6 ? `${s.slice(0, 4)}.${s.slice(4)}` : s;
    }

    _c(n) { return Number(n || 0).toLocaleString(); }

    destroy() {}
}
